import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { clientApi } from '@/config/axios';
import { useAuth } from '@/lib/auth/AuthContext';

export interface OrganizationOut {
  id: string;
  name: string;
  settings: Record<string, unknown> | null;
  created_at: string;
  updated_at: string;
}

export function useOrganization() {
  const { organization } = useAuth();
  const orgId = organization?.organization_id;

  return useQuery<OrganizationOut>({
    queryKey: ['organization', orgId],
    enabled: !!orgId,
    queryFn: async () => {
      const { data } = await clientApi.get<OrganizationOut>(
        `/api/v1/organizations/${orgId}`,
      );
      return data;
    },
  });
}

export function useUpdateOrganization() {
  const queryClient = useQueryClient();
  const { organization } = useAuth();
  const orgId = organization?.organization_id;

  return useMutation({
    mutationFn: async (body: { name?: string; settings?: Record<string, unknown> | null }) => {
      const { data } = await clientApi.patch<OrganizationOut>(
        `/api/v1/organizations/${orgId}`,
        body,
      );
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['organization', orgId] });
    },
  });
}
